module.exports = __webpack_public_path__ + "static/img/4.3642fb6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/sp/4.png
// module id = 6NK0
// module chunks = 0